import { useContext } from 'react'

import { CarouselScrollContext, type ICarouselScrollContext } from './CarouselScrollContext'

export const useCarouselScroll = (): ICarouselScrollContext => {
  return useContext(CarouselScrollContext)
}

export default useCarouselScroll
